import { Children, useEffect } from "react";
import { TableCore, TableRowCore, TdCore } from "src/Pages/components";
import { useContextCompany } from "src/Contexts/Company/CompanyContext";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";

import { TheadPayments } from "./TheadPayments";

import { UseGetPaymentMethod } from "./UseGetPaymentMethod";
import { Box, Chip } from "@mui/material";
import { getLinkWhatApp } from "src/Pages/components/CardPlans/CardPlans";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { CancelOutlined, HelpCenter } from "@mui/icons-material";

import {
  colorStatusDueDate,
  CompChipsStatusPayment,
  ObjMethodPayment,
  objStatusPayment,
} from "./Components/colorStatusDueDate";

export const TablePayments = () => {
  const { handleGet } = UseGetPaymentMethod();
  const { userPerfil } = useAuthContext();
  const { valuesPaymentCheckout } = useContextCompany();

  const handleClickOpen = (url: string) => {
    window.open(url, "_blank");
  };

  useEffect(() => {
    handleGet();
  }, []);

  return (
    <TableCore
      isNotPagination
      THead={<TheadPayments />}
      cardAdd={{
        buttons: [
          <>
            <Box
              component="a"
              href={getLinkWhatApp(
                "5511984939024",
                `Olá, me chamo ${userPerfil?.name}, e tenho dúvidas: `
              )}
              sx={{ textDecoration: "none", marginRight: "8px" }}
              target="_blank"
            >
              <ButtonCore
                size="small"
                startIcon={<HelpCenter />}
                title="Tirar dúvidas"
                variant="outlined"
              />
            </Box>
            <Box
              component="a"
              href={getLinkWhatApp(
                "5511984939024",
                `Olá, me chamo ${userPerfil?.name}, quero cancelar meu plan: .`
              )}
              sx={{ textDecoration: "none" }}
              target="_blank"
            >
              <ButtonCore
                size="small"
                startIcon={<CancelOutlined />}
                title="Cancelar plano/Gerenciar"
              />
            </Box>
          </>,
        ],
      }}
      title="Histórico de pagamento"
      heightTable="calc(500px - 6rem)"
      qtdList={valuesPaymentCheckout?.length}
      sxStyle={{ margin: 0, padding: 0 }}
    >
      {Children.toArray(
        valuesPaymentCheckout?.map((item) => {
          return (
            <TableRowCore>
              <TdCore
                values={`${FormatDateBR(item.dueDate)}`}
                sxStyle={{
                  color: colorStatusDueDate(
                    item.dueDate,
                    item.status === "CONFIRMED"
                  ),
                }}
              />
              <TdCore
                values={`R$ ${FormatMoney(item.value.toFixed(2))}`}
                textAlign="right"
              />

              <TdCore
                textAlign="center"
                values={CompChipsStatusPayment({
                  icon: ObjMethodPayment[
                    item?.billingType ||
                      userPerfil?.subscription?.methodPayment ||
                      "NOT_DEFINED"
                  ].icon,
                  label:
                    ObjMethodPayment[
                      item?.billingType ||
                        userPerfil?.subscription?.methodPayment ||
                        "NOT_DEFINED"
                    ].label,
                })}
              />

              <TdCore
                values={`${
                  item?.paymentDate ? FormatDateBR(item.paymentDate) : ""
                }`}
                textAlign="right"
              />

              <TdCore
                textAlign="center"
                onClick={() =>
                  item.status !== "CONFIRMED" &&
                  userPerfil?.subscription?.methodPayment !== "CREDIT_CARD"
                    ? handleClickOpen(item.invoiceUrl)
                    : null
                }
                values={
                  <Chip
                    variant="outlined"
                    sx={{
                      width: "130px",
                      cursor:
                        item.status !== "CONFIRMED" &&
                        userPerfil?.subscription?.methodPayment !==
                          "CREDIT_CARD"
                          ? "pointer"
                          : "default",
                    }}
                    icon={
                      objStatusPayment[
                        item.status as keyof typeof objStatusPayment
                      ].icon
                    }
                    label={
                      objStatusPayment[
                        item.status as keyof typeof objStatusPayment
                      ].label
                    }
                    color={
                      objStatusPayment[
                        item.status as keyof typeof objStatusPayment
                      ].color as "success" | "warning"
                    }
                  />
                }
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
